import {Component} from "@angular/core";

@Component({
  selector: 'app-page-not-found',
  template: ''
})
export class PageNotFoundComponent {

}
